'use strict';

module.exports = function(s) {
  return s.substr(0, 1).toUpperCase() + s.substring(1);
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/ucfirst/ucfirst.js
// module id = 46
// module chunks = 0